<script>
import DashboardLayout from "@/Layouts/DashboardLayout.vue";

export default {
    layout: DashboardLayout,
};
</script>

<script setup>
import { computed, ref } from "vue";
import { Head, usePage } from "@inertiajs/vue3";
import AccountNav from "@/Components/Account/AccountNav.vue";
import FriendsHero from "@/Components/Friends/FriendsHero.vue";
import AccountSettingsSection from "@/Pages/Profile/Partials/AccountSettingsSection.vue";
import BrowserSessionsSection from "@/Pages/Profile/Partials/BrowserSessionsSection.vue";
import DeleteAccountSection from "@/Pages/Profile/Partials/DeleteAccountSection.vue";
import PasswordSection from "@/Pages/Profile/Partials/PasswordSection.vue";

defineProps({
    sessions: {
        type: Array,
        default: () => [],
    },
});

const user = computed(() => usePage().props.auth.user);

const SECTIONS = ["settings", "password", "sessions", "delete"];

// Deep links (e.g. the legacy account-settings/password route) land here
// with ?section=…; switching is client-side, with the URL kept in sync.
const initialSection = new URLSearchParams(window.location.search).get(
    "section",
);

const section = ref(
    SECTIONS.includes(initialSection) ? initialSection : "settings",
);

function selectSection(key) {
    section.value = key;

    const url = new URL(window.location.href);

    if (key === "settings") {
        url.searchParams.delete("section");
    } else {
        url.searchParams.set("section", key);
    }

    window.history.replaceState(window.history.state, "", url);
}
</script>

<template>
    <div>
        <Head>
            <title>Manage Account | Gift Hero</title>
        </Head>

        <FriendsHero title="Manage Account" />

        <div class="md:grid md:grid-cols-[352px_1fr] md:gap-16">
            <!-- Desktop sidebar overlaps the hero band; mobile renders tabs -->
            <div class="md:-mt-[137px]">
                <AccountNav :active="section" @select="selectSection" />
            </div>

            <div class="mt-6 min-w-0 pb-10 md:mt-[61px] md:pb-16">
                <AccountSettingsSection
                    v-if="section === 'settings'"
                    :user="user"
                />
                <PasswordSection v-else-if="section === 'password'" />
                <BrowserSessionsSection
                    v-else-if="section === 'sessions'"
                    :sessions="sessions"
                />
                <DeleteAccountSection v-else-if="section === 'delete'" />
            </div>
        </div>
    </div>
</template>
